import { Component, EventEmitter, OnChanges } from '@angular/core';
import { filter } from 'rxjs/operators';
import { BaseComponent } from '../../shared/base-components/base.component';
import { ModalSize } from '../../shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerIndividualBiometric } from '../models/customer-individual-biometric.model';
import { EyeColorType } from '../models/enums/eye-color-type.enum';
import { GenderType } from '../models/enums/gender-type.enum';
import { HairColorType } from '../models/enums/hair-color-type.enum';
import { CustomerManageService } from '../shared/customer-manage.service';
import { CustomerAttributeContext, CustomerAttributeModalComponent } from './customer-attributes-modal.component';
import { HistoricalAttributesContext, HistoricalCustomerAttributesModalComponent } from './historical-customer-attributes-modal.component';

@Component({
    selector: 'customer-attributes',
    templateUrl: './customer-attributes.html',
    inputs: ['customerNumber', 'attribute', 'canEdit'],
    outputs: ['editedAttribute']
})

export class CustomerAttributesComponent extends BaseComponent implements OnChanges {
    public attributes: CustomerIndividualBiometric[] = [];
    public customerNumber: number;
    public attribute: CustomerIndividualBiometric;
    public canEdit: boolean;
    private eyeColorTypes = new EyeColorType();
    private hairColorTypes = new HairColorType();
    private genderTypes = new GenderType();
    public editedAttribute: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
    public viewHistory = true;

    constructor(
        public modalService: MvdModalService,
        private customerService: CustomerManageService
    ) {
        super();
    }

    ngOnInit() {
        if (this.attribute != null) {
            this.viewHistory = !this.attribute['isBiometricRedacted'];
            this.denormalizeData();
        } else if (this.customerNumber != null) {
            this.populateAttributes(this.customerNumber);
        }
    }

    ngOnChanges() {
        if (this.attribute != null) {
            this.viewHistory = !this.attribute['isBiometricRedacted'];
            this.denormalizeData();
        } else if (this.customerNumber != null) {
            this.populateAttributes(this.customerNumber);
        }
    }

    populateAttributes(customerNumberId: number) {
        this.customerService.getCustomerAttributes(customerNumberId)
            .subscribe(result => {
                this.attribute = result;
                this.viewHistory = !this.attribute['isBiometricRedacted'];
            },
            e => console.log('error', e),
            () => {
                this.denormalizeData();
            });
    }

    denormalizeData() {
        let feet = '';
        let inches = '';

        if (this.attribute.height != null) {
            feet += Math.floor(this.attribute.height / 12).toString() + ' FT';

            if ((this.attribute.height % 12) > 0) {
                inches += ' ' + (this.attribute.height % 12).toString() + ' IN';
            }
        }

        this.attribute.displayHeight = feet + inches;
        this.attribute.displayWeight = this.attribute.weight != null ? this.attribute.weight.toString() + ' LBS' : '';
        this.attribute.gender = this.getValues(this.attribute.genderTypeId, this.genderTypes);
        this.attribute.eyeColor = this.getValues(this.attribute.eyeColorTypeId, this.eyeColorTypes);
        this.attribute.hairColor = this.getValues(this.attribute.hairColorTypeId, this.hairColorTypes);

        this.attributes = [];
        this.attributes.push(this.attribute);
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }

    editAttribute(id) {
        const data = new CustomerAttributeContext(this.customerNumber);
        this.modalService.open(CustomerAttributeModalComponent, data, ModalSize.Medium).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(
                () => {
                    this.populateAttributes(this.customerNumber);
                    this.editedAttribute.emit();
                }
            );
    }

    showHistory(id) {
        const data = new HistoricalAttributesContext(this.customerNumber);
        this.modalService.open(HistoricalCustomerAttributesModalComponent, data);
    }
}
